// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selected-country-info[data-v-9c78086c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 16px;\n  font-size: 16px;\n}\n.selected-country-info .country-name[data-v-9c78086c] {\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
